
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../../commonFunctions";
  
  const help = {
    label: "Menu Help",
    pageLabel: "Menu Help",
    starting: true,
    url: "help",
    pageType: "history",
    form: [
        
        {
            inputType: "displaytext",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Search",
            name: "",
            description: ""
          },

          {
            inputType: "text",
            isRequired: true,
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Search",            
            name: "Search",
            description: "Enter Search"
          },
          
         
    ]
}

export default help;